(function () {
  const PARAM_HANDLE = 'pinned_handle';
  const PARAM_ID = 'pinned_id';

  const escapeSelector = (value) => {
    if (typeof value !== 'string') return value;
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }
    return value.replace(/["\\]/g, '\\$&');
  };

  const findPinnedItem = (grid, params) => {
    const handle = params.get(PARAM_HANDLE);
    if (handle) {
      const selector = `[data-product-handle="${escapeSelector(handle)}"]`;
      const node = grid.querySelector(selector);
      if (node) return node;
    }

    const id = params.get(PARAM_ID);
    if (id) {
      return grid.querySelector(`[data-product-id="${escapeSelector(id)}"]`);
    }

    return null;
  };

  const applyPinnedProduct = () => {
    const params = new URLSearchParams(window.location.search || '');
    if (!params.has(PARAM_HANDLE) && !params.has(PARAM_ID)) return;

    const grid = document.querySelector('#ProductGridContainer #product-grid');
    if (!grid) return;

    const pinnedItem = findPinnedItem(grid, params);
    if (!pinnedItem || pinnedItem === grid.firstElementChild) return;

    grid.insertBefore(pinnedItem, grid.firstElementChild);
    pinnedItem.dataset.pinnedFirst = 'true';

    if (pinnedItem.style && pinnedItem.style.setProperty) {
      pinnedItem.style.setProperty('--animation-order', '1');
    }
  };

  const handleRender = () => {
    try {
      applyPinnedProduct();
    } catch (error) {
      console.warn('collection-pin apply error', error);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleRender);
  } else {
    handleRender();
  }

  document.addEventListener('collection:product-grid-rendered', handleRender);
  document.addEventListener('shopify:section:load', handleRender);
})();
